import React from 'react'


// function LoanAdminEl(){
//     return (
//         <>
         
//         </>
//     )
// }

// function LenderElement(){
//     return(
//         <>
            
        
//         </>
//     )
// }
export default function CalendarPageTest() {
  return (
    <div>
       
    <div class="peopleContainer">
        <h2 class="peopleHeader">People</h2>
    <div class="People">
            <h2>Lender</h2>
            <form>
                <label for="organization">Organization:</label><br/>
                <input type="text" placeholder="Organization name"/><br/><br/>
                <label for="first name">First name:</label><br/>
                <input type="text" placeholder="First name"/><br/><br/>
                <label for="last name">Last name:</label><br/>
                <input type="text" placeholder="Last name"/><br/><br/>
                <label for="email">Email:</label><br/>
                <input type="text" placeholder="Email"/><br/><br/>
                <label for="phone number">Phone number:</label><br/>
                <input type="text" placeholder="Phone number"/><br/><br/>
            </form>
        </div>

        <div class="People">
            <h2>Loan Admin</h2>
            <form>
                <label for="organization">Organization:</label><br/>
                <input type="text" placeholder="Organization name"/><br/><br/>
                <label for="first name">First name:</label><br/>
                <input type="text" placeholder="First name"/><br/><br/>
                <label for="last name">Last name:</label><br/>
                <input type="text" placeholder="Last name"/><br/><br/>
                <label for="email">Email:</label><br/>
                <input type="text" placeholder="Email"/><br/><br/>
                <label for="phone number">Phone number:</label><br/>
                <input type="text" placeholder="Phone number"/><br/><br/>
            </form>
        </div>

    <div class="People">
      <h2>Borrower</h2>
      <form>
        <label for="organization">Organization:</label><br/>
        <input type="text" placeholder="Organization name"/><br/><br/>
        <label for="first name">First name:</label><br/>
        <input type="text" placeholder="First name"/><br/><br/>
        <label for="last name">Last name:</label><br/>
        <input type="text" placeholder="Last name"/><br/><br/>
        <label for="email">Email:</label><br/>
        <input type="text" placeholder="Email"/><br/><br/>
        <label for="phone number">Phone number:</label><br/>
        <input type="text" placeholder="Phone number"/><br></br>
      </form>
    </div>

    <div class="People">
      <h2>Builder</h2>
      <form>
        <label for="organization">Organization:</label><br/>
        <input type="text" placeholder="Organization name"/><br/><br/>
        <label for="first name">First name:</label><br/>
        <input type="text" placeholder="First name"/><br/><br/>
        <label for="last name">Last name:</label><br/>
        <input type="text" placeholder="Last name"/><br/><br/>
        <label for="email">Email:</label><br/>
        <input type="text" placeholder="Email"/><br/><br/>
        <label for="phone number">Phone number:</label><br/>
        <input type="text" placeholder="Phone number"/><br></br>
      </form>
    </div>

    <div class="People">
      <h2>Inspector</h2>
      <form>
        <label for="organization">Organization:</label><br/>
        <input type="text" placeholder="Organization name"/><br/><br/>
        <label for="first name">First name:</label><br/>
        <input type="text" placeholder="First name"/><br/><br/>
        <label for="last name">Last name:</label><br/>
        <input type="text" placeholder="Last name"/><br/><br/>
        <label for="email">Email:</label><br/>
        <input type="text" placeholder="Email"/><br/><br/>
        <label for="phone number">Phone number:</label><br/>
        <input type="text" placeholder="Phone number"/><br/><br/>
      </form>
    </div>

  </div>

  <div class="loanContainter">
    <h2 class="loanInfoHeader">Loan Information</h2>

    <div class="loanInfoFormDiv">
      <form class="loanInfoForm">
        <label for="loan #">Loan #:</label><br/>
        <input class="loanNumInput" type="text" placeholder="Loan #"/><br/><br/>
        <label for="Propery Address">Property Address</label>
        <div>
          <div class="streetContainer">
            <label for="street">Street</label><br/>
            <input class="streetInput" type="text" placeholder="Street"/><br/><br/>
          </div>
          <div class="streetContainer">
            <label for="street 2">Street 2</label><br/>
            <input class="streetInput" type="text" placeholder="Street"/><br/><br/>
          </div>
        </div>
        <div>
          <div class="cityStateZipContainer">
            <label for="City">City</label><br/>
            <input type="text" placeholder="City"/><br/><br/>
          </div>
          <div class="cityStateZipContainer">
            <label for="State">State</label><br/>
            <input class="stateInput" type="text" placeholder="**"/><br/><br/>
          </div>
          <div class="cityStateZipContainer">
            <label for="Zip">Zip</label><br/>
            <input type="text" placeholder="Zip"/><br/><br/>
          </div>
        </div>        
      </form>
    </div>

  </div>

  <div class="costsContainer">
    <h2 class="costsHeader">Soft Costs</h2>

    <div>
      <form class="costsForm">

        <div class="verticalCenter">

          <div class="costFormDiv">
            <button>Add</button>
          </div>
          <div class="costFormDiv">
            <label>Item</label><br/>
            <input class="itemInput" type="text" placeholder="Item"/><br/><br/>
          </div>
          <div class="costFormDiv">  
            <label>Budget</label><br/>
            <input class="budgetInput" type="text" Placeholder="$0.00"/><br/><br/>
          </div>

        </div>

      </form>
    </div>

  </div>

  <div class="costsContainer">
    <h2 class="costsHeader">Hard Costs</h2>
    <div>
        <form class="costsForm">
            <div class="verticalCenter">
                <div class="costFormDiv">
                    <button>Add</button>
                </div>
                <div class="costFormDiv">
                    <label>Item</label><br/>
                    <input class="itemInput" type="text" placeholder="Item"/><br/><br/>
                </div>
                <div class="costFormDiv">  
                    <label>Budget</label><br/>
                    <input class="budgetInput" type="text" Placeholder="$0.00"/><br/><br/>
                </div>
            </div>
        </form>
    </div>
  </div>


    </div>
  )
}
